import { render, staticRenderFns } from "./shopPurchase.vue?vue&type=template&id=2b606569&scoped=true&"
import script from "./shopPurchase.vue?vue&type=script&lang=js&"
export * from "./shopPurchase.vue?vue&type=script&lang=js&"
import style0 from "./shopPurchase.vue?vue&type=style&index=0&id=2b606569&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b606569",
  null
  
)

export default component.exports